(() => {

  // Active Link Mouseover Section
  const handleMouseover = (event, className) => {
    const classes = event.target.classList
    const isParentEl = [...classes].includes(className)
    removeActiveClass()
    addActiveClass(event.target, isParentEl)
    openSubmenu(event.target)
  }
  
  const removeActiveClass = () => {
    const currentActive = document.querySelector('.activeNavLink')
    if (!currentActive) return
    
    currentActive.classList.remove('activeNavLink')
    closeSubmenu(currentActive.parentElement.nextElementSibling)
  }

  const addActiveClass = (target, isParentEl) => {
    const targetEl = isParentEl ? target.firstElementChild : target
    if (!targetEl) return

    targetEl.classList.add('activeNavLink')
  }
  
  const openSubmenu = (element) => {
    const targetEl = element.nextElementSibling !== null ? element.nextElementSibling : element.parentElement.nextElementSibling
    if (!targetEl) return

    targetEl.style.display = 'grid'
  }

  const closeSubmenu = (element) => {
    if (!element) return

    element.style.display = 'none'
  }
  
  

  // Active Link Mouseout Section
  const makeMouseOutFunction = (element) => {
    const list = traverseChildren(element)
    return function onMouseOut(event) {
        const e = event.toElement || event.relatedTarget
        if (!!~list.indexOf(e)) return
        removeActiveClass()
    }
  }
                                                                            
  const traverseChildren = (element) => {
    // BFS Children Traversal 
    const pushAll = (elementArray) => {
      for (let i = 0; i < elementArray.length; i++){
        q.push(elementArray[i])
      }  
    }
    
    const children = []
    const q = []
    q.push(element)
  
    while (q.length > 0) {
      const element = q.pop()
      children.push(element)
      pushAll(element.children)
    }
  
    return children
  }


  // Add Event Handlers
  const parent = document.querySelector(".list-menu--inline--custom")
  parent.addEventListener('mouseout', makeMouseOutFunction(parent), true)

  const navItemsWithSubmenuClass = 'header-first-submenu__menu-item--custom'
  const navItemsWithSubmenu = document.querySelectorAll('.' + navItemsWithSubmenuClass)
  navItemsWithSubmenu.forEach(item => {
    item.addEventListener('mouseover', () => handleMouseover(event, navItemsWithSubmenuClass))
  })
  
  const navItemsSubmenulessClass = 'header__menu-item-not-last--custom'
  const navItemsSubmenuless = document.querySelectorAll('.' + navItemsSubmenulessClass)
  navItemsSubmenuless.forEach(item => {
    item.addEventListener('mouseover', () => handleMouseover(event, navItemsSubmenulessClass))
  })
  
  
  // Header Button Hover, remove active class
  const headerButton = document.querySelector('.header__menu-item-last--custom')
  if (headerButton) headerButton.addEventListener('mouseover', () => removeActiveClass())

})()